import { render, staticRenderFns } from "./retur.vue?vue&type=template&id=408fd4e7&scoped=true&"
import script from "./retur.vue?vue&type=script&lang=js&"
export * from "./retur.vue?vue&type=script&lang=js&"
import style0 from "./retur.vue?vue&type=style&index=0&id=408fd4e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408fd4e7",
  null
  
)

export default component.exports